import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import * as styles from './product-info-price-ds.styles'

export interface BelowBlockSavingsProps {
  savingPercentage?: number
  perUnitSavingsPercentage: string
  showSavingPercentage: boolean
}

// V2 savings row rendered below the price wrapper; sale-price savings win over per-unit.
function BelowBlockSavings({
  savingPercentage,
  perUnitSavingsPercentage,
  showSavingPercentage,
}: BelowBlockSavingsProps) {
  const { t } = useTranslation('common')
  return (
    <div
      className={cx(
        styles.priceWrapperMainTextCss,
        styles.priceWrapperMainTextNewDesignV2Css,
        styles.priceWrapperMainMarginCss,
      )}
    >
      {t('save')} <span>{showSavingPercentage ? savingPercentage : perUnitSavingsPercentage}</span>
      {t('compared_to_traditional_retail')}
    </div>
  )
}

export default BelowBlockSavings
